import { EmptyState, Heading, Icons, Paragraph } from "@ir/ui";

const NoDeduction = () => {
  return (
    <EmptyState
      className="bg-white border-1 border-color-grey-25 px-4 py-5 m-2"
      icon={Icons.InfoOctagon}
      title={
        <Heading level={6} className="text-grey-700 font-bold mt-3">
          No Data Found
        </Heading>
      }
      description={<Paragraph className="text-grey-500 font-regular mb-0">This is where you can view all your Deductions</Paragraph>}
    />
  );
};

export default NoDeduction;
